import { SpinAndHoldCommonConfiguration } from "../../../api";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldBonus_1Screen } from "../SpinAndHold/SpinAndHold_1Screen";
export class BigSymbolSpinAndHoldBonus_1Screen extends SpinAndHoldBonus_1Screen{
	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		throw new Error("Method not implemented.");
	}
	
	protected override BonusName(): string
	{
		return "BigSymbolSpinAndHold";
	}

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
	}
}

